<div class="p-card text-left my-4 py-4 px-3">
  <h6>RESUMEN DE TOTALES</h6>
  <ng-container *ngFor="let item of resumenTotalesEntries()">
    <p>{{ getLabel(item[0]) }}: <span>{{ item[1] }}</span></p>
  </ng-container>
</div>
